
    import '/home/runner/work/GPT-Vis/GPT-Vis/src/ConfigProvider/index.en.md?watch=parent';
    export const demoIndex = {
  ids: ["configprovider-demo-plot-theme","configprovider-demo-map-config","configprovider-demo-components-config","configprovider-demo-graph-components-config"],
  getter: () => import(/* webpackChunkName: "meta__ConfigProvider__en" */'/home/runner/work/GPT-Vis/GPT-Vis/src/ConfigProvider/index.en.md?type=demo')
};